import { Form, Space, Input, DatePicker, Button, Flex } from "antd";
import React from "react";
import SearchApi from "../../api-services/search-api.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";

const monthFormat = "MMM YYYY";

function SearchBarWidget() {
  const searchApi = new SearchApi;
  const navigate= useNavigate();
  const [searchParams] =  useSearchParams();

  const save = (formValues) => {
    let searchObj = {};
    if(formValues.keyword) searchObj = {keyword: formValues.keyword};
    
    if(formValues.date){
      searchObj["year"] = formValues.date.$y;
      searchObj["month"] = new Date(formValues.date).toLocaleString('default', { month: 'short' });
    }
    
    const searchParams = new URLSearchParams(searchObj).toString();
    navigate(`/web/listing?${searchParams}`);
    navigate(0);

    // searchApi.search(formValues.keyword, formValues.month)
    //   .then(result => {
    //       navigate(`/web/listing?keyword=${formValues.keyword}`);
    //   })
  }
  
  
  return (
    <div id="search-bar">
        <img src="/iceholidays-assets/images/Rectangle49.png"/>
        <div id="search-bar-widget">
          <Form
            onFinish={save}
            layout="vertical"
          >
            <Form.Item wrapperCol={{ span: 24 }} label="Search" name="keyword">
              <Input placeholder="Destinations, Attractions, etc"/>
            </Form.Item>
            <Form.Item wrapperCol={{ span: 24 }} label="Travel Period" name="date">
              <DatePicker picker="month" format={monthFormat} inputReadOnly/>
            </Form.Item>
            <Flex align="flex-end" justify="center">
              <Button type="primary" className="search-button" htmlType="submit">Search</Button>
            </Flex>
          </Form>
        </div>
        <img src="/iceholidays-assets/images/Rectangle49.png" className="flip"/>
      </div>
  )
}

export default SearchBarWidget;